import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  CustomInput,
  Alert
} from 'reactstrap';
import { AvForm, AvField, AvInput } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { successToaster, errorToaster } from "../../../components/Common/Toaster";

import {
  setBusinessLocation,
  addBusinessLocation,
  editBusinessLocation,
  emptyBusinessLocation,
  updateBusinessLocation,
  getUsers,
  getProductsList,
  getPosIntegrationsList
} from '../../../store/actions';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { httpGet } from '../../../utils/http';
import { VENDORS_ENDPOINT } from '../../../config/endPoints';

class BusinessLocationAdd extends React.Component {
  /**
   * component state
   */
  state = {
    id: '',
    businessLocation: localStorage.getItem('businessLocation'),
    showAIButton: false,
    submitPressed: false
  };

  /**
   * Component Did Mount
   */
  componentDidMount() {
    const { businessLocation } = this.state;
    this.props.getUsers();
    this.props.getProductsList();
    this.props.getPosIntegrationsList();

    const route = this.props.location.pathname;
    let arr = route.split('/');
    let id = arr[3];
    if (id !== undefined) {
      this.props.editBusinessLocation(id);
      this.setState({
        id,
      });
    }

    if(!businessLocation){
      errorToaster('You do not have a business location to manage. Please add your first loation', 'Error');
    }

    setTimeout(() => {
      if(this.props.productsList.length == 0){
        this.setState({
          showAIButton: true
        })
      }
    }, 2000)
  }

  /**
   * component Will Unmount
   */
  componentWillUnmount() {
    // this.props.emptyBusinessLocation();
  }

  /**
   * submit handle
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      businessLocation: {
        business_name,
        business_address,
        business_country_id,
        business_state_id,
        business_state,
        business_city,
        business_zip_code,
        par_levels_enabled,
        assigned_to,
        is_slave,
      },
    } = this.props;

    const { id } = this.state;

    if (
      !business_name ||
      !business_address ||
      !business_country_id ||
      !business_city ||
      !business_zip_code 
    ) {
      errorToaster('Please fill required fields', 'Error')
      return false;
    }

    if (business_country_id == 244 &&
      !business_state_id
    ) {
      errorToaster('Please fill required fields', 'Error')
      return false;
    }

    if (business_country_id != 244 &&
      !business_state
    ) {
      errorToaster('Please fill required fields', 'Error')
      return false;
    }

    if(id) {
      this.props.updateBusinessLocation(this.props.history, id)

      this.setState({
        submitPressed: true
      });

      setTimeout(() =>{
        localStorage.removeItem("token");
        localStorage.removeItem("businessLocation");
        localStorage.removeItem("businessLocationObject");
        localStorage.removeItem("pendingAdditionalInfo");
        localStorage.removeItem("pendingParLevels");
        localStorage.removeItem("pendingUnits");
        localStorage.removeItem("wookaiUserObject");
        localStorage.removeItem("firstBusinessLocationObject");
        this.props.history.push('/login');
        successToaster('You are logged out', 'Success.')
      }, 2000)
    }
    else{
      this.props.history.push({
        pathname: '/subscription',
        search: '?newLocation=true',
        state: {secondLocationAdd: true}
      })
      // this.props.addBusinessLocation(this.props.history)
    }
  };

  //Form Input onChange
  changeHandeler = (event) => {
    this.props.setBusinessLocation({
      field: event.target.name,
      value: event.target.value,
    });
  };

  // slave checkbox change
  slaveCheck = (event) => {
    const {businessLocation: {is_slave}} = this.props;

    this.props.setBusinessLocation({
      field: event.target.name,
      value: is_slave == 1 ? 0 : 1,
    });
  }

  // enterprise checkbox change
  enterPriseCheck = (event) => {
    const {businessLocation: {enterprise}} = this.props;
    this.props.setBusinessLocation({
      field: event.target.name,
      value: enterprise == 1 ? 0 : 1,
    });
  }

  // commisary checkbox change
  commisaryCheck = (event) => {
    const {businessLocation: {is_commisary}} = this.props;

    this.props.setBusinessLocation({
      field: event.target.name,
      value: is_commisary == 1 ? 0 : 1,
    });
  }

  startAIProcess = async () => {
    httpGet(`${VENDORS_ENDPOINT}/createAIItemList/fromVendorItems`);

    successToaster('AI setup has started. Please wait up to 2 hours.', 'Success');
  }

  /**
   * render component
   */
  render() {
    const {
      countries,
      states,
      users,
      productsList,
      posIntegrationList,
      businessLocation: {
        business_name,
        business_address,
        business_country_id,
        business_state_id,
        business_state,
        business_city,
        business_zip_code,
        par_levels_enabled,
        assigned_to,
        is_slave,
        enterprise,
        is_commisary,
        gpt_key,
        pos_public_key,
        pos_secret_key,
        fk_pos_integration_id,
        pos_location_id,
        pos_refresh_token
      },
    } = this.props;


    const {id, businessLocation, showAIButton, submitPressed} = this.state;

    return (
      <React.Fragment>
        <div className='page-content'>
          <Container fluid={true}>
            <Breadcrumbs title='Business Locations' breadcrumbItem='Add' />
            <Row>
              <Col xl='12'>
                <Card>
                  <CardBody>
                     <p className="card-title-desc">
                      {/* Provide valuable, actionable feedback to your users with
                      HTML5 form validation–available in all our supported
                      browsers. */}
                      {
                        submitPressed &&
                        <Alert color="warning" role="alert">
                          You need to logout to make the changes effect.
                        </Alert>
                      }
                    </p>
                    {/* <h4 className='card-title'>React Validation - Normal</h4>
                    <p className='card-title-desc'>
                      Provide valuable, actionable feedback to your users with
                      HTML5 form validation–available in all our supported
                      browsers.
                    </p> */}
                    <AvForm
                      className='needs-validation'
                      onSubmit={this.handleSubmit}
                    >
                      <Row>
                        <Col md='4'>
                          <FormGroup>
                            <Label htmlFor='validationCustom01'>
                              Name of Business
                            </Label>
                            <input
                              className={`form-control ${
                                business_name ? '' : 'is-invalid'
                              }`}
                              value={business_name}
                              name='business_name'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>
                              Enter business name
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md='8'>
                          <FormGroup>
                            <Label htmlFor='validationCustom02'>Address</Label>
                            <input
                              className={`form-control ${
                                business_address ? '' : 'is-invalid'
                              }`}
                              value={business_address}
                              name='business_address'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>
                              Enter Address
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md='4'>
                          <FormGroup>
                            <Label htmlFor='validationCustom03'>Country</Label>
                            <select
                              value={business_country_id}
                              onChange={(event) => this.changeHandeler(event)}
                              className={`form-control ${
                                business_country_id ? '' : 'is-invalid'
                              }`}
                              name='business_country_id'
                            >
                              <option disabled value="">
                                --select--
                              </option>
                              {countries.map((country, i) => {
                                return (
                                  <option key={i} value={country.id}>
                                    {country.country_name}
                                  </option>
                                );
                              })}
                            </select>
                            <div className='invalid-feedback'>
                              Select Country
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md='4'>
                          <FormGroup>
                            <Label htmlFor='validationCustom04'>State</Label>
                            {business_country_id == 244 && (
                              <select
                                value={business_state_id}
                                onChange={(event) => this.changeHandeler(event)}
                                className={`form-control ${
                                  business_state_id ? '' : 'is-invalid'
                                }`}
                                name='business_state_id'
                              >
                                <option disabled value="">
                                  --select--
                                </option>
                                {states.map((val, i) => {
                                  return (
                                    <option key={i} value={val.id}>
                                      {val.state_name}
                                    </option>
                                  );
                                })}
                              </select>
                            )}
                            {business_country_id != 244 && (
                              <input
                                className={`form-control ${
                                  business_state ? '' : 'is-invalid'
                                }`}
                                value={business_state}
                                name='business_state'
                                type='text'
                                onChange={(event) => this.changeHandeler(event)}
                              />
                            )}
                            <div className='invalid-feedback'>Select State</div>
                          </FormGroup>
                        </Col>
                        <Col md='4'>
                          <FormGroup>
                            <Label htmlFor='validationCustom04'>City</Label>
                            <input
                              className={`form-control ${
                                business_city ? '' : 'is-invalid'
                              }`}
                              value={business_city}
                              name='business_city'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>Enter City</div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md='4'>
                          <FormGroup>
                            <Label htmlFor='validationCustom03'>Zip</Label>
                            <input
                              className={`form-control ${
                                business_zip_code ? '' : 'is-invalid'
                              }`}
                              value={business_zip_code}
                              name='business_zip_code'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>Enter Zip</div>
                          </FormGroup>
                        </Col>
                        <Col md='4'>
                          <FormGroup>
                            <Label htmlFor='validationCustom04'>
                              PAR Levels
                            </Label>
                            <select
                              value={par_levels_enabled}
                              onChange={(event) => this.changeHandeler(event)}
                              className={`form-control`}
                              name='par_levels_enabled'
                            >
                              <option disabled value="">
                                --select--
                              </option>
                              <option value='1'>Enable</option>
                              <option value='0'>Disable</option>
                            </select>
                            <div className='invalid-feedback'>
                              Select Par levels
                            </div>
                          </FormGroup>
                        </Col>
                        { !id &&
                           <Col md='4'>
                           <FormGroup>
                             <Label htmlFor='validationCustom04'>
                               Assigned To
                             </Label>
                             <select
                               value={assigned_to}
                               onChange={(event) => this.changeHandeler(event)}
                               className={`form-control`}
                               name='assigned_to'
                             >
                               <option disabled value="">
                                 --select--
                               </option>
                               {users.map((user, userIndex) => {
                                 return (
                                   <option key={userIndex} value={user.id}>
                                     {user.full_name} {user.user_type}
                                   </option>
                                 );
                               })}
                             </select>
                             <div className='invalid-feedback'>Select User</div>
                           </FormGroup>
                         </Col>
                        }
                        {
                          (is_slave == 0) && 
                          <Col md='4'>
                            <FormGroup>
                              <Label htmlFor='validationCustom03'>GPT  Key</Label>
                              <input
                                className={`form-control`}
                                value={gpt_key}
                                name='gpt_key'
                                type='text'
                                onChange={(event) => this.changeHandeler(event)}
                              />
                              <div className='invalid-feedback'>Enter GPT key</div>
                            </FormGroup>
                          </Col>
                        }
                      </Row>
                       
                      <Row>
                          { is_slave == 0 && 
                          <>
                        <Col md='1'>
                          <FormGroup>
                            <Label htmlFor='validationCustom03'>POS Integration</Label>
                            <select
                              value={fk_pos_integration_id}
                              onChange={(event) => this.changeHandeler(event)}
                              className={`form-control`}
                              name='fk_pos_integration_id'
                              // disabled={fk_pos_integration_id}
                              // style={{
                              //   backgroundColor: fk_pos_integration_id
                              //     ? "#f1f1f1"
                              //     : "",
                              //   }}
                            >
                              <option value="">
                                --select--
                              </option>
                              {posIntegrationList.map((posIntegration, i) => {
                                return (
                                  <option key={i} value={posIntegration.id}>
                                    {posIntegration.pos_name}
                                  </option>
                                );
                              })}
                            </select>
                            <div className='invalid-feedback'>
                              Select POS
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md='3'>
                          <FormGroup>
                            <Label htmlFor='validationCustom03'>Public Key</Label>
                            <input
                              className={`form-control`}
                              value={pos_public_key}
                              name='pos_public_key'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>Enter Public Key</div>
                          </FormGroup>
                        </Col>
                        <Col md='3'>
                          <FormGroup>
                            <Label htmlFor='validationCustom03'>Secret Key</Label>
                            <input
                              className={`form-control`}
                              value={pos_secret_key}
                              name='pos_secret_key'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>Enter Secret Key</div>
                          </FormGroup>
                        </Col>
                        </>
                        }
                        <Col md='3'>
                          <FormGroup>
                            <Label htmlFor='validationCustom03'>Location Id</Label>
                            <input
                              className={`form-control`}
                              value={pos_location_id}
                              name='pos_location_id'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>Enter Location Id</div>
                          </FormGroup>
                        </Col>
                        <Col md='2'>
                          <FormGroup>
                            <Label htmlFor='validationCustom03'>Refresh Token</Label>
                            <input
                              className={`form-control`}
                              value={pos_refresh_token}
                              name='pos_refresh_token'
                              type='text'
                              onChange={(event) => this.changeHandeler(event)}
                            />
                            <div className='invalid-feedback'>Enter Refresh Token</div>
                          </FormGroup>
                        </Col>
                      </Row>
                        


                      {/* show only when we are in some location already */}
                      {
                        businessLocation
                        &&
                        <Row>
                          <Col md='3'>
                            <FormGroup>
                              <div className='custom-checkbox mb-3'>
                                <label
                                  className='custom-checkbox-label d-flex gap-2 align-items-center'
                                  htmlFor='customCheck1'
                                >
                                <input
                                  className='form-control'
                                  style={{
                                    backgroundColor: id
                                      ? "#f1f1f1"
                                      : "",
                                  }}
                                  value={is_slave}
                                  checked={is_slave}
                                  name='is_slave'
                                  type='checkbox'
                                  id='customCheck1'
                                  onChange={(event) => this.slaveCheck(event)}
                                  disabled={id ? true : false}
                                />
                                
                                  This is subsidiary business location.
                                </label>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md='3'>
                            <FormGroup>
                              <div className='custom-control1 custom-checkbox mb-3'>
                                 <label
                                  className='custom-checkbox-label d-flex gap-2 align-items-center'
                                  htmlFor='customCheck2'
                                >
                                <input
                                  className='custom-control-input1 form-control'
                                  value={enterprise}
                                  checked={enterprise}
                                  name='enterprise'
                                  type='checkbox'
                                  id='customCheck2'
                                  onChange={(event) => this.enterPriseCheck(event)}
                                />
                               
                                  Enterprise
                                </label>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md='3'>
                            <FormGroup>
                              <div className='custom-checkbox mb-3'>
                                 <label
                                  className='custom-checkbox-label d-flex gap-2 align-items-center'
                                  htmlFor='customCheck3'
                                >
                                <input
                                  className='form-control'
                                  value={is_commisary}
                                  checked={is_commisary}
                                  name='is_commisary'
                                  type='checkbox'
                                  id='customCheck3'
                                  onChange={(event) => this.commisaryCheck(event)}
                                />
                               
                                  Commisary/Supplier
                                </label>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md='3'>
                          {
                            (is_slave == 0 && showAIButton) &&
                            <FormGroup>
                              <Button 
                                color='primary' 
                                onClick={() => {
                                    if (
                                      window.confirm(
                                        'Are you sure to Run?'
                                      )
                                    ) {
                                      this.startAIProcess();
                                    }
                                  }}
                                >
                                Run AI Setup
                              </Button>
                            </FormGroup>
                          }
                          </Col>
                        </Row>
                      }
                      

                      <Button color='primary' type='submit' className="orange-btn">
                        Submit
                      </Button>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { businessLocation, loading } = state.BusinessLocation;
  const { countries } = state.Country;
  const { states } = state.State;
  const {users} = state.User
  const { productsList } = state.Product;
  const {posIntegrationList} = state.PosIntegration;


  return { businessLocation, countries, states, loading, users, productsList, posIntegrationList };
};

export default withRouter(
  connect(mapStatetoProps, {
    setBusinessLocation,
    addBusinessLocation,
    editBusinessLocation,
    emptyBusinessLocation,
    updateBusinessLocation,
    getUsers,
    getProductsList,
    getPosIntegrationsList
  })(BusinessLocationAdd)
);
